import React, {Component} from 'react';
import Main from '../Main';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setLoadingGetRole, getRole, getRoleSuccess, getRoleError, 
    setLoadingPatchRole, patchRole, patchRoleSuccess, patchRoleError} from '../../actions/RoleActions';
import { path_roles } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';
import {TRANSLATE_EDIT_ROLE, TRANSLATE_ROLE_NAME, TRANSLATE_CANCEL, TRANSLATE_SAVE} from '../../translates/Translates';

class EditRole extends Component{
    constructor(props){
        super(props);

        this.state = {
            role: {},
        }
    }

    componentDidMount = () => {
        this.props.setLoadingGetRole();
        this.props.getRole(this.props.match.params.role_id).then((response) => {
            this.setState({role: response.payload.data});
            this.props.getRoleSuccess();
        }).catch(() => {
            this.props.getRoleError();
        })
    }

    onChangeField = (event) => {
        const value = event.target.value;
        this.setState((prevState) => {
            let role = {...prevState.role};
            role.name = value;
            return {
                ...prevState,
                role
            }
        })
    }

    deleteForm = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                role: {
                    name: '',
                }
            }
        })
    }

    submitForm = (userData) => {
        this.props.setLoadingPatchRole();
        this.props.patchRole(userData).then((response) => {
            this.props.patchRoleSuccess();
        }).catch(() => {
            this.props.patchRoleError();
        })
    }

    render(){
        return(
            <div>
                <Main/>
                <div className="page-wrapper">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info"> 
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">{TRANSLATE_EDIT_ROLE}</h4>
                                    </div>
                                    <div className="card-body">
                                        {this.props.loadingGetRole ? (
                                            <div className="preloader">
                                                <svg className="circular" viewBox="25 25 50 50">
                                                    <circle className="path" cx="50" cy="50" r="20" fill="none" />
                                                </svg>
                                            </div>
                                        ) : (
                                            <form method="post">
                                                <div className="form-body">
                                                    <div className="row pt-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="control-label">{TRANSLATE_ROLE_NAME}</label>
                                                                <input type="text" id="name" name="name" className="form-control" value={this.state.role.name} onChange={this.onChangeField} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6"></div>
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="button" className="btn btn-success mr-3" onClick={() => this.submitForm(this.state.role)}> 
                                                        <i className="fa fa-check"></i>&nbsp;{TRANSLATE_SAVE}
                                                    </button>
                                                    <Link to={path_roles} className="btn btn-inverse" >{TRANSLATE_CANCEL}</Link>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        loadingGetRole: state.roleReducer.loadingGetRole
    }
} 

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingGetRole,
        getRole,
        getRoleSuccess,
        getRoleError,
        setLoadingPatchRole,
        patchRole,
        patchRoleSuccess,
        patchRoleError
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRole);
